import { Button, Container, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { userSaas } from "../validations/Validation";
import { toast } from "react-toastify";
import { postSAAS } from "../services/post.service";
import { useNavigate } from "react-router-dom";

interface SAASForm {
    email: string;
    name: string;
    firstName: string;
    middleName: string;
    lastName: string;
    password: string;
    confirmPassword: string;
    phoneNumber: string;
    pic_url: File;
}

const RegisterSAAS = () => {
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()

    const { register, handleSubmit, formState: { errors } } = useForm<SAASForm>({
        resolver: yupResolver(userSaas)
    })

    const onSubmit = (data: any) => {
        setLoading(true)
        const loading = toast.loading("Please wait...", {
            theme: "colored",
            type: "info",
            closeButton: true,
        })

        var formData = new FormData()
        
        formData.append("name", data.name)
        formData.append("firstName", data.firstName)
        formData.append("middleName", data.middleName)
        formData.append("lastName", data.lastName)
        formData.append("email", data.email)
        formData.append("password", data.password)
        formData.append("phoneNumber", data.phoneNumber)
        formData.append("confirmPassword", data.confirmPassword)
        if(data.pic_url.length > 0)
            formData.append("pic_url", data.pic_url[0])

        postSAAS(formData)
            .then((res) => {
                toast.update(loading, {
                    render: res.data,
                    type: "success",
                    theme: "colored",
                    autoClose: 2500,
                    isLoading: false,
                    closeOnClick: true,
                    hideProgressBar: false,
                });
                setLoading(false);
                navigate("/");
            })
            .catch((err) => {
                toast.update(loading, {
                    render: err?.response?.data || "Some Error happened",
                    theme: "colored",
                    autoClose: 5000,
                    type: "error",
                    isLoading: false,
                    closeOnClick: true,
                    hideProgressBar: false,
                });
                setLoading(false);
                console.log(err);
            })
    }

    return <>
        <Helmet>
            <title>Register SAAS</title>
        </Helmet>
        <Container className="bg-amber50 m-4 lg:m-12">
            <Typography className="pt-6 text-xl font-bold" variant="h5" align="center">Register SAAS</Typography>
            <div className="p-10 px-3 lg:px-44">
                <form className="grid gap-3" onSubmit={handleSubmit(onSubmit)}>
                    <div>
                        <TextField size="small" fullWidth label="Your Clinic Name" {...register("name")} error={errors.name ? true : false} />
                        <p color="error" className="text-red-700 text-sm">{errors.name?.message}</p>
                    </div>
                    <div>
                        <TextField size="small" fullWidth label="Logo" type="file" {...register("pic_url")} error={errors.pic_url ? true : false} />
                        <p color="error" className="text-red-700 text-sm">{errors.pic_url?.message}</p>
                    </div>
                    <div>
                        <TextField size="small" fullWidth label="First Name" {...register("firstName")} error={errors.firstName ? true : false} />
                        <p color="error" className="text-red-700 text-sm">{errors.firstName?.message}</p>
                    </div>
                    <div>
                        <TextField size="small" fullWidth label="Middle Name" {...register("middleName")} error={errors.middleName ? true : false} />
                        <p color="error" className="text-red-700 text-sm">{errors.middleName?.message}</p>
                    </div>
                    <div>
                        <TextField size="small" fullWidth label="Last Name" {...register("lastName")} error={errors.lastName ? true : false} />
                        <p color="error" className="text-red-700 text-sm">{errors.lastName?.message}</p>
                    </div>
                    <div>
                        <TextField size="small" fullWidth label="Email" type="email" {...register("email")} error={errors.email ? true : false} />
                        <p color="error" className="text-red-700 text-sm">{errors.email?.message}</p>
                    </div>
                    <div>
                        <TextField size="small" fullWidth label="Phone Number" {...register("phoneNumber")} error={errors.phoneNumber ? true : false} />
                        <p color="error" className="text-red-700 text-sm">{errors.phoneNumber?.message}</p>
                    </div>
                    <div>
                        <TextField size="small" fullWidth label="Password" type="password" {...register("password")} error={errors.password ? true : false} />
                        <p color="error" className="text-red-700 text-sm">{errors.password?.message}</p>
                    </div>
                    <div>
                        <TextField size="small" fullWidth label="Confirm Password" type="password" {...register("confirmPassword")}
                            error={errors.confirmPassword ? true : false} />
                        <p color="error" className="text-red-700 text-sm">{errors.confirmPassword?.message}</p>
                    </div>
                    <Button variant="contained" disabled={loading} type="submit" fullWidth>Submit</Button>
                </form>
            </div>
        </Container>
    </>;
};

export default RegisterSAAS;
